export const setState = (state) => {
  return {
    type: "SET_CLASSPROGRESS_STATE",
    payload: state,
  };
};

export default { setState };
